import DurationDaysField from './DurationDaysField.component';

export default DurationDaysField;